module.exports = __webpack_public_path__ + "img/error-page-bg-dark.8ac92481.png";